import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";

import { contactEmail } from "@const/contactEmail";
import { toggleBlockedUserModal } from "@redux/blockedUserModal/actions";

import styles from "./index.module.scss";

const BlockedUserModal = () => {
  const dispatch = useDispatch();
  const { isVisible } = useSelector(
    ({ blockedUserModalReducer }) => blockedUserModalReducer,
  );

  const { t } = useTranslation("modals");
  const { t: t1 } = useTranslation("common");

  const toggleModal = () => {
    dispatch(toggleBlockedUserModal(!isVisible));
  };

  return (
    <Modal
      size="sm"
      toggle={toggleModal}
      onConfirm={toggleModal}
      onClose={toggleModal}
      confirmText={t1("OK")}
      title={t("BLOCKED_ACCOUNT")}
      dialogClassName={styles.dialog}
      showCancel={false}
      isOpen={isVisible}
    >
      <div className="text-primary text-center text-body-1 text-regular">
        {t("BLOCKED_ACCOUNT_CONTACT")}
        <a
          href={`mailto:${contactEmail}`}
          className="ms-1 link-primary text-decoration-none text-semibold"
        >
          {contactEmail}
        </a>
      </div>
    </Modal>
  );
};

export default BlockedUserModal;
